// Compiled using marko@4.28.10 - DO NOT EDIT
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry = require("marko/dist/runtime/components/registry"),
    marko_registerComponent = components_registry.r,
    marko_componentType = marko_registerComponent("/wetracker$1.0.0/src/components/monitors/templates/monitors.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_forRange = require("marko/dist/runtime/helpers/for-range"),
    marko_attrs0 = {
        "class": "monitors"
      },
    marko_attrs1 = {
        "class": "monitors-row"
      },
    marko_attrs2 = {
        "class": "monitors-row"
      },
    marko_attrs3 = {
        "class": "monitor"
      },
    marko_attrs4 = {
        "class": "track-name"
      },
    marko_attrs5 = {
        "class": "monitor"
      },
    marko_attrs6 = {
        "class": "track-name"
      },
    marko_attrs7 = {
        "class": "monitor monitor-empty"
      },
    marko_attrs8 = {
        "class": "monitors"
      },
    marko_attrs9 = {
        "class": "monitors-row"
      },
    marko_attrs10 = {
        "class": "monitor"
      },
    marko_attrs11 = {
        "class": "track-name"
      };

function render(input, out, __component, component, state) {
  var data = input;

  if (data.numtracks > 6) {
    out.be("div", marko_attrs0, "0", component);

    out.be("div", marko_attrs1, "1", component);

    var $for$0 = 0;

    marko_forRange(0, data.columns - 1, null, function(c) {
      var $keyScope$0 = "[" + (($for$0++) + "]");

      out.e("div", marko_attrs3, "2" + $keyScope$0, component, 2)
        .e("canvas", {
            id: "vu" + c,
            "data-trackindex": "" + c,
            style: "width:100%;height:100%;",
            "class": "monitor-canvas"
          }, "3" + $keyScope$0, component, 0)
        .e("span", marko_attrs4, "4" + $keyScope$0, component, 1)
          .t(data.tracknames[c], component);
    });

    out.ee();

    out.be("div", marko_attrs2, "5", component);

    var $for$1 = 0;

    marko_forRange(0, data.columns - 1, null, function(c) {
      var $keyScope$1 = "[" + (($for$1++) + "]");

      if ((c + data.columns) < data.numtracks) {
        out.e("div", marko_attrs5, "6" + $keyScope$1, component, 2)
          .e("canvas", {
              id: "vu" + (c + data.columns),
              "data-trackindex": "" + (c + data.columns),
              style: "width:100%;height:100%;",
              "class": "monitor-canvas"
            }, "7" + $keyScope$1, component, 0)
          .e("span", marko_attrs6, "8" + $keyScope$1, component, 1)
            .t(data.tracknames[c + data.columns], component);
      } else {
        out.e("div", marko_attrs7, "9" + $keyScope$1, component, 0);
      }
    });

    out.ee();

    out.ee();
  } else {
    out.be("div", marko_attrs8, "10", component);

    out.be("div", marko_attrs9, "11", component);

    if (data.numtracks > 0) {
      var $for$2 = 0;

      marko_forRange(0, data.numtracks - 1, null, function(c) {
        var $keyScope$2 = "[" + (($for$2++) + "]");

        out.e("div", marko_attrs10, "12" + $keyScope$2, component, 2)
          .e("canvas", {
              id: "vu" + c,
              "data-trackindex": "" + c,
              style: "width:100%;height:100%;",
              "class": "monitor-canvas"
            }, "13" + $keyScope$2, component, 0)
          .e("span", marko_attrs11, "14" + $keyScope$2, component, 1)
            .t(data.tracknames[c], component);
      });
    }

    out.ee();

    out.ee();
  }
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
